export default __webpack_public_path__ + "static/media/Acolyte's Belt of Sacrifice.4779ef03.jpg";